import Column from '@sdk/components/ui/spacing/Column';
import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';

import UserEmptyStateSvg from '@web/assets/svg/Misc/user-empty-state.svg';

const EmployeeEmptyState = () => (
  <Column mTop={20} alignItems="center">
    <Column mTop={20} mLeft={34} mBottom={20}>
      <UserEmptyStateSvg />
    </Column>
    <Text14 themeColor={ThemeColorType.gray} semiBold>
      {gettext('Looks like you have no employees yet.')}
    </Text14>
    <Text14 themeColor={ThemeColorType.gray} semiBold>
      {gettext('Add employees to be able to schedule your team.')}
    </Text14>
  </Column>
);

export default EmployeeEmptyState;
